import { ContactUs } from '@/features/support';
import { AppLayout } from '@/layouts/AppLayout/AppLayout';
import { Button } from '@/ui/components';
import { warning } from '@/assets/images/emojis';
import styles from './ErrorPage.module.scss';
import { Icon } from '@/ui/icons/Icon';

export const ErrorPage = ({ onReload }: { onReload: () => void }) => {
  return (
    <AppLayout>
      <div className={styles.root}>
        <div className={styles.content}>
          <div className={styles.topSection}>
            <div className={styles.header}>
              <img src={warning} alt="Warning" className={styles.warningIcon} />
              <div className={styles.textContent}>
                <h2 className={styles.title}>
                  Întâmpinăm o <br /> problemă tehnică.
                </h2>
                <p className={styles.message}>
                  Te rugăm să reîncerci. Dacă problema <br /> persistă,
                  contactează echipa de suport.
                </p>
              </div>
            </div>
          </div>

          <ContactUs buttonVariant="outlined" />
        </div>

        <div className={styles.bottomSection}>
          <Button
            trackingId="error_page_retry"
            text="Reîncarcă"
            onClick={onReload}
            className={styles.reloadButton}
            leftIcon={<Icon name="rotate" />}
          />
        </div>
      </div>
    </AppLayout>
  );
};
